import type { CloudBadge } from "@/lib/workModel";
import { cn } from "@/lib/utils";

/**
 * The cloud brokerage label's badge: "Cloud brokerage", or "Part of a cloud
 * brokerage" on a managed office of one. Plain words, no icon, so the meaning
 * never rests on a symbol. Renders nothing for any other organization.
 * Wording comes only from workModelView / publicWorkModelView.
 * Spec: docs/superpowers/specs/2026-10-16-cloud-brokerage-label-design.md §4
 */
export default function WorkModelBadge({ badge, className }: { badge: CloudBadge | null; className?: string }) {
  if (!badge) return null;
  return (
    <span
      data-work-model-badge
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-[4px] border border-border bg-card px-1.5 py-0.5 text-[12px] font-medium leading-none text-ink-700",
        className,
      )}
    >
      {badge}
    </span>
  );
}
